
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]/[article_slug]",
      function () {
        return require("private-next-pages/blog/[slug]/[article_slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[slug]/[article_slug]"])
      });
    }
  